import * as _ from 'lodash';
import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { MaterialService } from '../../services/material/material.service';
import { ArrayModel } from '../complex/array.model';
import { CompositeModel } from '../complex/composite.model';
import { CrmCodeModel } from '../complex/crm-code.model';
import { DopModel } from '../complex/dop.model';
import { MaterialModel, MaterialOutModel } from '../low-level/material.model';
import { NotificationModel } from '../low-level/notification.model';

export class ConfirmationMaterialConsumeModel extends CompositeModel {
    public listMaterial: ArrayModel<MaterialModel>;
    public notification: NotificationModel;
    public dopSet: DopModel[];
    public showComplaintFieldBasedOnUserStatus: boolean;
    public frontId: string;
    public isOptionYesSelectedInComplaints = false;
    public constructor(notificationModel: NotificationModel) {
        super('ConfirmationMaterialConsumeModel');

        const injector = CustomInjector.getInjector();
        const materialService = injector.get(MaterialService);

        // set the notification identifier
        this.notification = notificationModel;

        const localMaterials = materialService.getAllMaterialsForNotification(this.notification.identifier);
        // create new array model of Material Model
        this.listMaterial = new ArrayModel<MaterialModel>('MaterialSet', localMaterials);

        this.dopSet = notificationModel.dopSet;
        // variable holds bool value for check based on user status value "PPI" or PSI"
        this.showComplaintFieldBasedOnUserStatus =
            notificationModel.userStatus.includes(ConfigConstants.USER_STATUS.PPI) ||
            notificationModel.userStatus.includes(ConfigConstants.USER_STATUS.PSI);

        this.frontId = notificationModel.identifier.frontId;
    }

    public getOutModel(): ODataConfirmationMaterialConsumeOutModel {
        const outModel = <ODataConfirmationMaterialConsumeOutModel>super.getOutModel();
        const crmCodes = <ArrayModel<CrmCodeModel>>this.set(new ArrayModel<CrmCodeModel>('CrmCodesSet'));
        this.listMaterial.value.map((material: MaterialModel) => {
            if (material.phiDataCode.selectedEntry) {
                crmCodes.addModel(
                    new CrmCodeModel({
                        codeType: 'M',
                        codeGroup: material.phiDataCode.selectedEntry.name,
                        code: material.phiDataCode.selectedEntry.value,
                        codeText: material.materialIdentifier.materialNumber.value.replace(/^0+/, ''), // remove leading zeroes if present
                    }),
                );
            }
        });
        _.merge(outModel, crmCodes.getOutModel());
        _.merge(outModel, this.listMaterial.getOutModel());
        return outModel;
    }
}

export interface ODataConfirmationMaterialConsumeOutModel extends ODataObject {
    MaterialSet: MaterialOutModel[];
}
